import React from "react";
import { FixedWidth, PagesHeading } from "../../../../CommonComponents/commonStyles";
import { Col, Tabs, Row } from "antd";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import {
  SelectTabsWrapper,
  ExtraContentWrapper,
  ExtraContentMobile,
  PagesHeadingWrapper,
} from "./styles";
import TabsAdvisorSuccessor from "./Components/TabAdvisorSuccessor";
import AdvisorForm from "./Components/AdvisorForm";
import {
  updateActiveFlow,
  updateActivePage,
  updateStepperConfig,
  fetchAccountData,
  updateActivePageStepNumber
} from "../../../../actions/globalActions";
import BreadcrumbComponent from "../../../../CommonComponents/Breadcrumb/Breadcrumb";
import {
  updateActivePageStepName,
  jsonTemp,
  isSecondaryAdvisor,
  getZipCode,updateDropdownValues,
  myAccountMandatoryMissing
} from "../../actions";
import history from "../../../../history/history";
import { getPrimaryAccount } from "../../../../utils/sessionUtil";
import { ContentProvider, ContentMessage, Types } from "../../../../CommonComponents/ContentMessages";
import Messages from "../../../../CommonComponents/Messages";

class NpaSetUpAccount extends React.Component {
  constructor(props) {
    super(props);
    this.newTabIndex = 0;    
    this.userType = history.location.state && history.location.state.hasOwnProperty('advisorType') ? history.location.state.advisorType : "primary";
    this.addSecondaryAdv = history.location.state && history.location.state.addSecondaryAdv ? true: false;
    this.mainHeading = "Edit Account Advisors";   
    const panes = [
      {
        title: <TabsAdvisorSuccessor advisor="Primary Advisor" />,
        content: (
          <AdvisorForm getTitle={ this.getTitle.bind(this) } addSecondaryAdv={this.addSecondaryAdv} handleAddAdvisor={this.add} advisorType="Primary" userType={this.userType}/>
        ),
        key: "primary"
      }
    ];
    this.state = {
      activeKey: panes[0].key,
      panes
    };
  }



  componentWillMount() {
    let data = {};
    if(process.env.REACT_APP_NODE_ENV === "development") {
      data = {
        metaData: {
          method: "GET",
          page: "EditAdvisor",
          url: {
            userDetails: "/npaAccount/userDetails/user/1",
            dropDownValues: "/npaAccount/dropdownValues/dropDown"
          }
        }
      }
    }else{
      data = {
        metaData: {
          method: "GET",
          page: "EditAdvisor",
          url: {
          userDetails: `/donor-portal/api/profile/${getPrimaryAccount().userId}/getAccountAdvisors`,
          dropDownValues: "/donor-portal/api/dropDownValues/getCodeValueMapping"
          }
        }
      }
    }  
    this.props.setActiveFlow("npaForm");
    this.props.setActivePage("myAccount");
    this.props.getOPABasicinfo(data);
  }
  componentDidMount() {
    this.props.setActivePageStepNumber(1);
    this.props.setActivePageStepName("step1Setup");
    this.props.myAccountMandatoryMissing(false);
  }
  setStepNum = () => {
    this.props.setActivePageStepNumber(1);
  };
  onChange = activeKey => {
    this.setState({ activeKey });
    let id = document.getElementsByClassName("ant-tabs-tab");
    if (activeKey === "primary") {
      id[1].style.borderRight = "1px solid #bfbfbf";
      id[1].style.borderLeft = "none";
    } else {
      id[0].style.borderLeft = "1px solid #bfbfbf";
      id[0].style.borderRight = "1px solid #bfbfbf";
    }
    this.props.myAccountMandatoryMissing(false);
  };
  onEdit = (targetKey, action) => {
    this[action](targetKey);
  };
  add = () => {
    window.scrollTo(0, 0);
    let id = document.getElementsByClassName("ant-tabs-tab");
    id[0].style.borderLeft = "1px solid #bfbfbf";
    const panes = this.state.panes;
    const activeKey = `newTab${this.newTabIndex++}`;
    panes.push({
      title: <TabsAdvisorSuccessor advisor="Secondary Advisor" />,
      content: (
        <AdvisorForm
          getTitle={ this.getTitle.bind(this) }
          advisorType="Secondary"
          addSecondaryAdv={this.addSecondaryAdv}
          userType={this.userType}
          handleRemoveAdvisor={this.remove}
        />
      ),
      key: activeKey
    });
    this.setState({ panes, activeKey });
  };
  remove = () => {
    window.scrollTo(0, 0);
    const panes = this.state.panes;
    panes.pop();
    this.setState({
      panes,
      activeKey: "primary"
    });
    if (this.props.isStep1Edit) {
      let tempData = this.props.tempData.tempJSON;
      tempData.advisors[1].title = "";
      tempData.advisors[1].firstname = "";
      tempData.advisors[1].middlename = "";
      tempData.advisors[1].lastname = "";
      tempData.advisors[1].dob = "";
      tempData.advisors[1].suffix = "";
      tempData.advisors[1].deliveryMethod = "ED";
      tempData.advisors[1].ssn = "";
      tempData.advisors[1].phones = [
        {
          phonenumber: "",
          phonetype: "",
          primary: true
        }
      ];
      tempData.advisors[1].emails = [
        {
          emailId: "",
          emailtype: "",
          primary: true
        }
      ];
      tempData.advisors[1].addresses = [
        {
          addresstype: "",
          primary: true,
          line1: "",
          line2: "",
          line3: "",
          zipcode: "",
          city: "",
          state: "",
          country: "0"
        }
      ];      
      this.props.jsonTemp({ tempJSON: tempData });
      this.props.isSecondaryAdvisor({
        isSecondaryAdvisor: false
      });
    }
  };
  updateSecondaryPane = () => {
    window.scrollTo(0, 0);
    let id = document.getElementsByClassName("ant-tabs-tab");
    if(!(id[0] === null || id[0] === undefined)) id[0].style.borderLeft = "1px solid #bfbfbf";
    const panes = this.state.panes;
    const activeKey = `newTab${this.newTabIndex}`;
    panes.push({
      title: <TabsAdvisorSuccessor advisor="Secondary Advisor" />,
      content: (
        <AdvisorForm
          getTitle={ this.getTitle.bind(this) }
          advisorType="Secondary"
          userType={this.userType}
          addSecondaryAdv={this.addSecondaryAdv}
          handleRemoveAdvisor={this.remove}
        />
      ),
      key: activeKey
    });
    this.setState({ panes }, () => {
      if(this.addSecondaryAdv)
        this.onChange(activeKey);
    });   
  }
  breadcrumbRoutes = () => {
    return [
      {
        routeName: "Home",
        path: "/"
      },
      {
        routeName: "My Account",
        path: "/my-account"
      },
      {
        routeName: () => <ContentMessage type={[Types.PAGE_TITLE_DESCRIPTION]} page="EAA" property="field_page_title" defaultMessage={this.mainHeading} />,
        path: ""
      }
    ];
  };
  setTitle = (title='') => {
    this.mainHeading = title;    
  }
  getTitle = () => {
    return this.mainHeading;
  }
  render() {
    const TabPane = Tabs.TabPane;
    if(this.state.panes.length === 1 && ((this.props.isSecondaryAdvisorSelected !== null && this.props.isSecondaryAdvisorSelected !== undefined) || this.addSecondaryAdv)){
      this.updateSecondaryPane();
    }
    const config = {
      extraContent: (
        <ExtraContentWrapper>
         All fields are required unless marked optional
        </ExtraContentWrapper>
      )
    };
    if(this.props.isError) window.scrollTo(0, 0);
    return (
      <ContentProvider types={[Types.PAGE_TITLE_DESCRIPTION, Types.PAGE_ALERTS]} pages={["EAA"]}>
        <FixedWidth>
          <BreadcrumbComponent breadcrumbRoutes={this.breadcrumbRoutes()} />
          {
          this.props.isError ? <>
          <PagesHeading marginBottom="20px">
           <ContentMessage type={[Types.PAGE_TITLE_DESCRIPTION]} page="EAA" property="field_page_title" defaultMessage={this.mainHeading} setTitle={this.setTitle}/>
          </PagesHeading>
          <div className="advisor-update-error-msg">            
            Some of the mandatory information is missing. Please contact us at 888-383-4483.
          </div>
        </>
        :  <PagesHeading marginBottom="50px">
            <ContentMessage type={[Types.PAGE_TITLE_DESCRIPTION]} page="EAA" property="field_page_title" defaultMessage={this.mainHeading} setTitle={this.setTitle}/>
          </PagesHeading>
        }

<Messages/>
        
          <Row>
            <Col lg={{span: 0}} xs={{ span: 24}}>
            <ExtraContentMobile>
              All fields are required unless marked optional
            </ExtraContentMobile>
            </Col>
          </Row>
          <SelectTabsWrapper>
            <Tabs
              hideAdd
              onChange={this.onChange}
              activeKey={this.state.activeKey}
              type="card"
              onEdit={this.onEdit}
              tabBarExtraContent={config.extraContent}
            >
              {this.state.panes.map((pane, index) => {
                return (
                  <TabPane
                    tab={pane.title}
                    key={pane.key}
                    closable={pane.closable}
                    data-test = "npaTabs"
                  >
                    {pane.content}
                  </TabPane>
                );
              })}
            </Tabs>
          </SelectTabsWrapper>
        </FixedWidth>
      </ContentProvider>
    );
  }
}
const mapStateToProps = state => ({
  stepCount: state.getIn(["myAccount", "activePageStepName"]),
  stepNum: state.getIn(["globalState", "activePageStepNumber"]),
  isStep1Edit: state.getIn([
    "myAccount",
    "isStep1Edit",
    "isStep1Edit",
    "isStep1Edit"
  ]),
  tempData: state.getIn(["myAccount", "tempJSON", "tempJSON"]),
  isError: state.getIn(["myAccount","submitEditAdvisorError","isError"]),
  isSecondaryAdvisorSelected: state.getIn(["myAccount", "isSecondaryAdvisor","isSecondaryAdvisor"]),
  myAccountMandatoryMissingFlag: state.getIn(["myAccount", "myAccountMandatoryMissingFlag"])
});
export const mapDispatchToProps = dispatch => ({
  setActiveFlow: flowName => dispatch(updateActiveFlow(flowName)),
  setActivePage: pageName => dispatch(updateActivePage(pageName)),
  setStepperConfig: config => dispatch(updateStepperConfig(config)),
  getOPABasicinfo: data => dispatch(fetchAccountData(data)),
  getZipCode: data => dispatch(getZipCode(data)),
  setActivePageStepNumber: stepNumber =>
    dispatch(updateActivePageStepNumber(stepNumber)),
  setActivePageStepName: stepName =>
    dispatch(updateActivePageStepName(stepName)),
  jsonTemp: val => dispatch(jsonTemp(val)),
  isSecondaryAdvisor: val => dispatch(isSecondaryAdvisor(val)),
  updateDropDownData: val => dispatch(updateDropdownValues(val)),
  myAccountMandatoryMissing: (data) => dispatch(myAccountMandatoryMissing(data))
});
export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(NpaSetUpAccount)
);
